

import React from 'react';

const Footer = ({ history }) => {
  return (
    <div>
      <footer className='footer'>
        <div className='footer-top'>
          <div className='container'>
            <div className='row text-center text-sm-left'>
              <div className='col-md-3 col-sm-4 footer-col-1'>
                <img
                  src='/images/logo.png'
                  className='footer-logo img-fluid mb-2'
                  alt=''
                />
                <ul>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('guarantee')}>icause guarantee</button>
                  </li>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('why-icause')}>Why icause</button>
                  </li>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('become-a-partner')}>Become Partner</button>
                  </li>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('become-investor')}>Become Investor</button>
                  </li>
                  <li>
                    {/* <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('why-icause')}>Privacy policy</button> */}
                  </li>
                  <li>
                    {/* <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('why-icause')}>Why icause</button> */}
                    {/* <a href='/homepage'>Terms & conditions</a> */}
                  </li>
                </ul>
              </div>
              <div className='col-md-3 col-sm-4 col-6'>
                <h5>Site Links</h5>
                <ul>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('/homepage')}>Home</button>
                  </li>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('/about')}>About us</button>
                  </li>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('/faq')}>Help & FAQ</button>
                  </li>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('/news')}>News</button>
                  </li>
                </ul>
              </div>
              <div className='col-md-2 col-sm-4 col-6'>
                <h5>Useful links</h5>
                <ul>
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('/starting_fund')}>Start fundraising</button>
                  </li>
                  {/* <li>
                    <a href='/homepage'>Clubs</a>
                  </li> */}
                  <li>
                    <button style={{ border: 'none', outline: 'none', background: 'none' }} onClick={() => history.push('/school')}>Schools</button>
                  </li>
                  {/* <li>
                    <a href='/homepage'>Communities</a>
                  </li> */}
                  {/*THESE ITEMS ARE TEMPORARY, WILL BE REMOVED LATER */}
                  {/* <li>
                    <a href='/campaign-details'>Campaign</a>
                  </li>
                  <li>
                    <a href='/upload-bill'>Upload Bill</a>
                  </li> */}
                  {/*THESE ITEMS ARE TEMPORARY, WILL BE REMOVED LATER */}
                </ul>
              </div>
              <div className='col-md-4 col-sm-12 our-news mt-4 mt-md-0'>
                <h2 className="main-heading mb-4">Subscribe our newsletter</h2>
                <div id='custom-search-input'>
                  <div className='input-group mb-4'>
                    <input
                      type='text'
                      className='  search-query form-control'
                      placeholder='Your Email'
                    />
                    <span className='input-group-btn'>
                      <button className='btn btn-success px-3' type='button'>
                        <span className='fa fa-arrow-right'></span>
                      </button>
                    </span>
                  </div>
                </div>
                <div className="app-stores-btns">
                  <a href="#!"><img className='mr-2' src='/images/app-store-2.png' alt='app' /></a>
                  <a href="#!"><img src='/images/play-store-2.png' alt='play' /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='footer-bottom'>
          <div className='container'>
            <div className='row align-items-center'>
              <div className='col-md-6 text-center text-md-left'>
                <p>Copyrights 2020-All rights reserved</p>
              </div>
              <div className='col-md-6 text-center text-md-right'>
                <ul className='social-icon d-inline-block mb-0 mt-3 mt-md-0'>
                  <li>
                    <a href='/homepage'>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href='/homepage'>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href='/homepage'>
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* SHARE POPUP */}
      <div id="share-popup" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>
            <div className="modal-body text-center">
              <h5>Do you like this? Share with your friends!</h5>
              <div className="mt-5">
                <ul className="share_links">
                  <li className="bg_fb"><a href="#!" className="share_icon"  rel="tooltip" title="Facebook"><i className="fa fa-facebook"></i></a></li>

                  <li className="bg_insta"><a href="#!" className="share_icon" rel="tooltip" title="Instagram"><i className=" fa fa-instagram"></i></a></li>

                  <li className="bg_linkedin"><a href="#!" className="share_icon" rel="tooltip" title="LinkedIn"><i className="fa fa-linkedin"></i></a></li></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Footer;

